import { List, Record } from 'immutable';
import moment from 'moment';

export const Ticket = new Record({
    'key': '',
    'et_id': '',
    'sku_code': '',
    'name': '',
    'operation_instructio_id': '',
    'operation_instructio_name': '',
    'is_online': 0,
    'created_date': moment(new Date()).format('YYYY-MM-DD'),
    'is_post': 1,
});

export const Info = new Record({
    'et_i_id': '',
    'et_id': '',
    'expiration_reminder': '',
    'expired_date': '',
    'href': '',
    'name': '',
    'created_date': moment(new Date()).format('YYYY-MM-DD'),
    'used_date': '',
    'is_already_used': '',
});


export const Instructio = new Record({
    'key': '',
    'et_io_id': '',
    'name': '',
    'content': '',
});
